import React from "react";
import Link from "gatsby-link";
import Helmet from "react-helmet";

import Publication from "../../components/publication";
import Videoframe from "../../components/videoframe";
import ExtLink from "../../components/ext-link";

import headerImg from "./img/chancellor-merkel-it-summit-ball-cameral.jpg";

export default () => (
  <div>
    <Helmet>
      <title>
        Throwable Panoramic Ball Camera at the National IT Summit 2012
      </title>
      <meta
        name="description"
        content="German Chancellor Dr. Merkel Checks out the Throwable Panoramic Ball Camera"
      />
      <style
      >{`ul#navigation li#contact-button { bottom: -67px !important; }`}</style>
    </Helmet>
    <h1>
      <span style={{ position: "absolute", fontSize: "28px", top: "9px" }}>
        Chancellor Merkel checks out
      </span>
      <span style={{ position: "absolute", top: "32px" }}>Ball Camera</span>
    </h1>
    <div id="videoframe" className="aspect4by3">
      <div id="videoplayer">
        <img
          src={headerImg}
          alt="German Chancellor Dr. Merkel Checks out the Throwable Panoramic Ball Camera"
        />
      </div>
    </div>

    <div id="description">
      <p>Photo: Bundesregierung / Jesco Denzel</p>

      <h2>
        German Chancellor Dr. Merkel Checks out the Throwable Panoramic Ball
        Camera
      </h2>
      <p>
        We have been invited to the National IT-Summit 2012 in Essen, an event
        organized by the Federal Ministry of Economics and Technology of
        Germany. During the main event federal minister for economics Dr.
        Phillipp Rösler threw the Throwable Panoramic Ball Camera. It became
        even more exciting when we had the chance to show our camera to the
        German Chancellor Dr. Angela Merkel.
      </p>
      <p>
        One day before the main event we attended the Young IT-Day which took
        place at the Folkwang University in Essen. It consisted of multiple
        discussions including business angels, politicians and a couple of
        start-ups. We had the opportunity to discuss the current climate for
        tech inventions in Germany with fellow innovators.
      </p>
    </div>
    <div id="facts">
      <dl>
        <dt>Date</dt>
        <dd>2012-10-13</dd>
      </dl>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/ballcamera/chancellor-merkel.jsx